import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

// ******* SHARING ************************************************

export const createShare = (
  content_type,
  document_id,
  target_type,
  target_team_id,
  message = "",
  company_name = "",
) => {
  try {
    return axios.post(
      BASE_URL + "share/create",
      {
        content_type,
        document_id,
        target_type,
        target_team_id,
        message,
        company_name,
      },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const acceptShare = (invite_id, content_type, document_id) => {
  try {
    return axios.post(
      BASE_URL + "share/accept",
      { invite_id, content_type, document_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const declineShare = (invite_id, content_type, document_id) => {
  try {
    return axios.post(
      BASE_URL + "share/decline",
      { invite_id, content_type, document_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const revokeShare = (content_type, document_id, target_uuid) => {
  try {
    return axios.post(
      BASE_URL + "share/revoke",
      { content_type, document_id, target_uuid },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const removeShare = (content_type, document_id, owner_uuid) => {
  try {
    return axios.post(
      BASE_URL + "share/remove",
      { content_type, document_id, owner_uuid },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getSharedWithMe = () => {
  try {
    return axios.get(BASE_URL + "share/getSharedWithMe", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getShareInfo = (content_type, document_id) => {
  try {
    return axios.get(
      BASE_URL +
        "share/getShareInfo?content_type=" +
        encodeURIComponent(content_type) +
        "&document_id=" +
        encodeURIComponent(document_id),
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const shareArticle = (
  documentId,
  targetType,
  targetTeamId,
  message,
  articleSnapshot,
) => {
  try {
    return axios.post(
      BASE_URL + "share/article",
      {
        document_id: documentId,
        target_type: targetType,
        target_team_id: targetTeamId,
        message: message || "",
        article_snapshot: articleSnapshot || {},
      },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};
